import { Component, Inject, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { fuseAnimations } from "@fuse/animations";
import { map, Observable } from "rxjs";

import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { IItemsPermissionActions } from "app/interfaces/IItemsPermissionActions";
import { format } from "date-fns";
import { BaseComponent, LoadingTeste } from "../../base-module/base-component/base.component";
import { AuthService } from "../../base-module/base-service/auth.service";
import { ListaAtividadeAssuntoService } from "../services/lista-atividade-assunto.service";
import { ListaAtividadeService } from "../services/lista-atividades.service";

export interface DialogData {
    id: number;
    is_alterar_data: boolean;
    is_assessor: boolean;
}

interface Actions {
    buttonContactRegistryFiles: IItemsPermissionActions;
}

@Component({
    selector: "cadastra-atividade-clientes",
    templateUrl: "./cadastra-atividade-clientes.component.html",
    styleUrls: ["./cadastra-atividade-clientes.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CadastraAtividadeClientesComponent extends BaseComponent {
    _actions: Actions = {
        buttonContactRegistryFiles: {
            permission: "Resgistrar Resposta Atividade",
            enabled: false,
        },
    };

    form = new FormGroup({
        nome: new FormControl("", [Validators.required]),
        cliente_id: new FormControl("", [Validators.required]),
        assunto_id: new FormControl("", [Validators.required]),
        data_hora_atividade: new FormControl<Date | null>(null, [Validators.required]),
        cliente: new FormControl("", [Validators.required]),
        atividade_id: new FormControl(""),
        observacao: new FormControl(""),
        resposta: new FormControl(""),
        valor: new FormControl(0),
        isOportunidade: new FormControl<number>(0),
        arquivos: new FormControl([]),
        is_assessor: new FormControl(true),
        resposta_id: new FormControl(""),
    });

    loadingLocal: any;
    loadingSpinnerAssunto: boolean = false;
    loadingSpinner: boolean = false;
    filteredOptions!: Observable<ClienteModel[]>;
    listAssunto: any[] = [];

    arquivosSelecionados: File[] = [];
    usuario: any;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;

    constructor(
        public _service: ListaAtividadeService,
        public _assuntoService: ListaAtividadeAssuntoService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public _authService: AuthService,
        private _clienteService: ClienteService,
        public dialogRef: MatDialogRef<CadastraAtividadeClientesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);
        this.getAllAssuntos();

        if (this.data != null && this.data != undefined && this.data.id != null) {
            this.getById();
        }
    }

    ngOnInit(): void {
        if (this.data != undefined && this.data.is_alterar_data != undefined && this.data.is_alterar_data) {
            this.form.get("nome")?.disable();
            this.form.get("cliente_id")?.disable();
            this.form.get("assunto_id")?.disable();
            this.form.get("cliente")?.disable();
            this.form.get("resposta")?.disable();
            this.form.get("valor")?.disable();
            this.form.get("isOportunidade")?.disable();
        }

        this.form.get("cliente")?.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map((response) => response.data));
            }
        });

        this.form.get("isOportunidade")?.valueChanges.subscribe((isOportunidade) => {
            if (isOportunidade != 1) {
                this.form.get("valor")?.setValue(0);
            }
        });

        // seta se a tarega é para assessor ou não
        this.form.get("is_assessor")?.setValue(this.data.is_assessor);

        this.verifyPermissionForActions();
    }

    verifyPermissionForActions() {
        this._actions.buttonContactRegistryFiles.enabled = this._authService.isPermissao([
            this._actions.buttonContactRegistryFiles.permission,
        ]);
    }

    displayFn(cliente: any) {
        if (cliente) {
            return cliente.nome;
        }
    }

    getCliente(cliente: any) {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    /**
     * Abre loagind
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha loagind
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal != null) {
            this.loadingLocal.close();
        }
    }

    isInvalidForm() {
        if (
            this.form.get("data_hora_atividade")?.value == null ||
            this.form.get("data_hora_atividade")?.value == undefined
        ) {
            return true;
        }

        if (this.form.get("assunto_id")?.value == null || this.form.get("assunto_id")?.value == undefined) {
            return true;
        }

        if (this.form.get("cliente")?.value == null || this.form.get("assunto_id")?.value == undefined) {
            return true;
        }

        if (this.form.get("valor")?.value == null || this.form.get("assunto_id")?.value == undefined) {
            return true;
        }

        return false;
    }

    salvar() {
        this.openLoading();

        const formData = this.buildFormData();
        // Adicionar os arquivos selecionados
        for (let i = 0; i < this.arquivosSelecionados.length; i++) {
            formData.append("arquivos[]", this.arquivosSelecionados[i]);
        }
        if (this.data == null || this.data.id == null) {
            this._service.create(formData).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    this.closeLoading();
                }
            );
        } else {
            formData.append("id", this.data.id.toString());
            this._service.update(this.data.id, formData).subscribe(
                (data) => {
                    this.closeLoading();
                    this.dialogRef.close(data);
                },
                (error) => {
                    this.closeLoading();
                    this.showError(error.error.message);
                },
                () => {
                    this.closeLoading();
                }
            );
        }
    }

    getById() {
        this.openLoading();
        this._service.getById(this.data.id).subscribe(
            (item) => {
                this.form.patchValue({
                    data_hora_atividade: new Date(item.data.data_hora_atividade),
                    assunto_id: item.data.assunto_id,
                    cliente_id: item.data.cliente_id,
                    cliente: item.data.cliente,
                    resposta: item.data.resposta,
                    resposta_id: item.data.tarefas_respostas_usuarios?.id ?? '',
                    observacao: item.data.observacao,
                    atividade_id: item.data.id,
                    valor: item.data.valor,
                });
            },
            (error) => {
                this.closeLoading();
            },
            () => {
                this.closeLoading();
            }
        );
    }

    getAllAssuntos() {
        this.loadingSpinnerAssunto = true;
        const filter = this.data.id ? {} : { is_subject_prosperidade: false };
        this._assuntoService.getLista(filter).subscribe(
            (list) => {
                this.listAssunto = list.data;
            },
            (error) => {
                this.loadingSpinnerAssunto = false;
            },
            () => {
                this.loadingSpinnerAssunto = false;
            }
        );
    }

    getErrorAssuntoMessage() {
        return this.form.get("assunto_id")?.hasError("required") ? "Assunto é um campo obrigatório" : "";
    }

    disabledItemByUpdateData() {
        if (this.data.is_alterar_data) return true;

        return false;
    }

    onFileSelected(event: any) {
        if (event.target.files.length > 0) {
            for (const file of event.target.files) {
                this.arquivosSelecionados.push(file);
            }
        }
    }

    removerArquivo(index: number) {
        this.arquivosSelecionados.splice(index, 1);
    }

    private buildFormData(): FormData {
        const formData = new FormData();

        const getValue = (key: string) => this.form.get(key)?.value;

        const cliente = getValue("cliente");
        if (cliente?.id) {
            formData.append("cliente_id", cliente.id.toString());
        }

        const assuntoId = getValue("assunto_id");
        if (assuntoId !== null && assuntoId !== undefined) {
            formData.append("assunto_id", assuntoId.toString());
        }

        formData.append("observacao", getValue("observacao") ?? "");
        formData.append("resposta", getValue("resposta") ?? "");
        formData.append("resposta_id", getValue("resposta_id") ?? "");

        const dataAtividade = getValue("data_hora_atividade");
        if (dataAtividade) {
            formData.append("data_hora_atividade", format(dataAtividade, "yyyy-MM-dd"));
        }

        const valor = getValue("valor");
        if (valor !== null && valor !== undefined) {
            formData.append("valor_sugerido", valor.toString());
        }

        formData.append("is_assessor", getValue("is_assessor")?.toString() ?? "false");

        // Adicionar arquivos
        for (let i = 0; i < this.arquivosSelecionados.length; i++) {
            formData.append("arquivos[]", this.arquivosSelecionados[i]);
        }

        return formData;
    }
}
